import { render, staticRenderFns } from "./AppPreviewWidget.vue?vue&type=template&id=42bd1872&scoped=true&"
import script from "./AppPreviewWidget.vue?vue&type=script&lang=js&"
export * from "./AppPreviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppPreviewWidget.vue?vue&type=style&index=0&id=42bd1872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd1872",
  null
  
)

export default component.exports